import '@css/main.css'
import Preloader from './components/preloader'
import MainNav from './components/main-nav'
import ContentSliders from './components/content-slider'
import ImageSlider from './components/image-slider'
import Video from './components/video'
import Parallax from './components/parallax'
import Faq from './components/faq'
import HorTextScroller from './components/horizontal-text-scroller'
import AnimateOnScroll from './components/animate-on-scroll'
import TableOfContents from './components/table-of-contents'
import Alert from './components/alert'
import StudiesOverview from './components/studies-overview'
import StudiesSlider from './components/studies-slider'
import Embeds from './components/embed'
import Search from './components/search'
import Tabs from './components/tabs'
import Timer from './components/timer'

class App {
    private initialized = false

    constructor() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.onDomReady())
        } else {
            this.onDomReady()
        }

        if (document.readyState === 'complete') {
            this.onComplete()
        } else {
            document.addEventListener('readystatechange', () => {
                if (document.readyState === 'complete') {
                    this.onComplete()
                }
            })
        }
    }

    private onDomReady() {
        new Preloader()
        new MainNav()
    }

    private onComplete() {
        if (this.initialized) return
        this.initialized = true
        const components = [
            Alert, ContentSliders, ImageSlider, Video, Parallax,
            Faq, HorTextScroller, AnimateOnScroll, TableOfContents,
            StudiesOverview, StudiesSlider, Embeds, Search, Tabs, Timer,
        ]
        for (const Component of components) {
            try {
                new Component()
            } catch (e) {
                console.error(`Failed to initialize ${Component.name}:`, e)
            }
        }
    }
}
window['App'] = new App()
